// The VAT codes of AFAS (its "btw-code"), which WLX keeps since 05-10-2026 (before: TALIS's 03, 01, 0, 09). The API
// keeps the same list and refuses any other code (services/api/src/modules/parties/vatCodes.ts).

export const VAT_CODES = ["1", "2", "3", "35"] as const;
export type VatCode = (typeof VAT_CODES)[number];

export const VAT_LABEL_KEYS: Record<VatCode, string> = {
  "1": "parties.vat1",
  "2": "parties.vat2",
  "3": "parties.vat3",
  "35": "parties.vat35",
};

/** Short, for a choice in a dense table: "1 · 21%", "35 · verlegd". */
export const VAT_SHORT_KEYS: Record<VatCode, string> = {
  "1": "parties.vatShort1",
  "2": "parties.vatShort2",
  "3": "parties.vatShort3",
  "35": "parties.vatShort35",
};

/** The code with what it means ("1 · Btw hoog (21%)"); an unknown code as it is. */
export function vatLabelKey(code: string | null | undefined): string | null {
  return code && code in VAT_LABEL_KEYS ? VAT_LABEL_KEYS[code as VatCode] : null;
}
